import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { errorAction, types as at } from "@authzsvc/api-lib";
import { selectFocusedRequest, isApiCallLoading } from "../../selectors";
import {
  cancelRequest,
  denyRequest,
  approveRequest,
  resolveIdentity,
} from "../../actions/api";
import { RequestDetails } from "@authzsvc/common-react-components";
import { showErrorNotification } from "../../util";
import { useNavigate, useParams } from "react-router-dom";
import { Spin, Card } from "antd";

const RequestDetailsWrapper = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  const requestData = useSelector((state) => selectFocusedRequest(state, id));
  const loading = useSelector(
    (state) =>
      isApiCallLoading(state, at.CANCEL_REQUEST) ||
      isApiCallLoading(state, at.DENY_REQUEST) ||
      isApiCallLoading(state, at.APPROVE_REQUEST)
  );

  const [request, setRequest] = useState(requestData?.request || null);
  const [requestor, setRequestor] = useState({});

  const getRequestor = useCallback(
    async (id) => {
      if (id) {
        const req = await dispatch(resolveIdentity(id));
        setRequestor(req.payload.data);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (!request && requestData?.request) {
      setRequest(requestData.request);
    }
  }, [request, requestData]);

  useEffect(() => {
    const fetchOwner = async () => {
      if (request?.requestorId) {
        await getRequestor(request.requestorId);
      }
    };
    fetchOwner();
  }, [request, getRequestor]);

  const goBack = () => {
    navigate("/requests");
  };

  const handleAction = async (actionFn, actionType, reason) => {
    const resp = await dispatch(actionFn(request.id, reason));
    if (resp.type === errorAction(actionType)) {
      showErrorNotification(resp.payload.title, resp.payload.data.message);
    }
    goBack();
  };

  const handleCancel = () => {
    handleAction(cancelRequest, at.CANCEL_REQUEST);
  };

  const handleApprove = (reason) => {
    handleAction(approveRequest, at.APPROVE_REQUEST, reason);
  };

  const handleDeny = (reason) => {
    handleAction(denyRequest, at.DENY_REQUEST, reason);
  };

  if (!request) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 40 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Card style={{ maxWidth: "50%", margin: "2rem auto", padding: "2rem" }}>
      <RequestDetails
        request={
          request ? { ...request, requestorName: requestor.displayName } : null
        }
        toApprove={requestData.toApprove}
        onApprove={handleApprove}
        onCancel={handleCancel}
        onDeny={handleDeny}
        loading={loading}
      />
    </Card>
  );
};

RequestDetailsWrapper.propTypes = {
  requestData: PropTypes.object,
};

export default RequestDetailsWrapper;
